import React, { useState, useEffect, useRef, useContext } from "react";
import MapRepairPoint from "./MapRepairPoint";
import { Form, Select, Collapse, Checkbox, Input, Button, AutoComplete } from "antd";
import Api from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import { StatusInfo } from "../../../utility/status_info_modal";
import { dynamicFunction } from "../../../../pages/uih/wf_controllers/BtnController/dynamicFunction";
import { handleForm } from "../../../../contexts";
import Modal from "antd/lib/modal/Modal";
import Renderbtn from "../../../../pages/uih/wf_controllers/BtnController/renderButton";
import { SearchOutlined } from '@ant-design/icons';
const { Option } = AutoComplete;
const { Panel } = Collapse;
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 14 },
};

export default function MapInfra({
  CompanyId,
  OperatorId,
  ProjectId,
  headerdata,
  Workflowdata,
}) {
  const [Formdata, setFormdata] = useState({
    problemtype: "",
    servicecase: "",
    servicetype: "",
  });
  /* masterdata */
  const [ProblemType, setProblemType] = useState([]);
  const [SeviceCase, setSeviceCase] = useState([]);
  const [ServiceType, setServiceType] = useState([]);
  const [disableForm, setdisableForm] = useState(false);
  const [showModal, setshowModal] = useState(false);
  const [spin, setspin] = useState(true);
  const [loadingText, setloadingText] = useState("Loading Action");
  const [statusInfoMode, setstatusInfoMode] = useState("success");
  const unmounted = useRef(false);
  const { form } = useContext(handleForm);

  const [checkRef, setCheckRef] = useState(false);
  const [referenceJob, setreferenceJob] = useState("");
  const [referenceData, setReferenceData] = useState([]);
  const [refJob, setrefJob] = useState(null);
  const [refJobIDGetData, setrefJobIDGetData] = useState(null);

  useEffect(() => {
    function FrtchData() {
      Api.post("master_data/get_job_service_type", {
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
      })
        .then((res) => {
          if (res.data.result.code === "P") {
            setServiceType(res.data.data?.result);
          }
        })
        .catch((e) => {
          console.log(e);
        });

      Api.post("master_data/get_job_service_cause", {
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
      })
        .then((res) => {
          if (res.data.result.code === "P") {
            setSeviceCase(res.data.data?.result);
          }
        })
        .catch((e) => {
          console.log(e);
        });

      Api.post("master_data/job_problem_type", {
        company_id: CompanyId,
        operator_id: OperatorId,
        project_id: ProjectId,
        job_type_id: headerdata.job_type_id,
      })
        .then((res) => {
          if (res.data.result.code === "P") {
            setProblemType(res.data.data?.result);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
    FrtchData();
    return () => {
      unmounted.current = true;
    };
  }, []);
  const callFunction = new dynamicFunction(
    CompanyId,
    OperatorId,
    ProjectId,
    headerdata,
    null,
    setshowModal,
    setloadingText,
    setspin,
    setstatusInfoMode,
    form
  );

  function OnSubmit(values) {
    const result = referenceData.filter(data => data.job_no === refJob);
    
    setloadingText("Loading Action");
    setdisableForm(true);

    Api.post("job_detail/Updatejobfixproblem", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_FixProblem_id: "0",
      job_progress_id: headerdata.job_progress_id,
      job_id: headerdata.job_id,
      problem_type_id: values.problemtype ?? null,
      service_cause_id: values.servicecase ?? null,
      service_type_id: values.servicetype ?? null,
      create_by: Cookies.get("username"),
      ref_job_id : refJobIDGetData
    })
      .then((res) => {
        if (res.data.result?.code === "P") {
          setloadingText("Go Next Action");
          const sendBtn = Workflowdata?.filter(
            (s) => s.next_main_action_id === 38
          )[0];
          callFunction
            .goNextAndReload(sendBtn)
            .then(() => {
              if (
                sendBtn.external_url_type &&
                sendBtn.external_url_type === "json"
              ) {
                setloadingText("Loading External URL");
                callFunction.CallExternalurl(JSON.parse(sendBtn.external_url));
              } else {
                setloadingText("Success");
                setspin(false);
              }
            })
            .catch((err) => {
              setloadingText(`Error : ${err.err}`);
              setspin(false);
              setstatusInfoMode("error");
            });
        } else if (res.data.result?.code === "F") {
          setloadingText(`Error : ${res.data.result?.showText}`);
          setspin(false);
          setstatusInfoMode("error");
          // notification.error({
          //   message: "Error",
          //   description: res.data.result?.showText,
          //   duration: 5,
          //   className: "font-thai-b fs-18",
          // });
          // setdisableForm(false);
        }
      })
      .catch((e) => {
        setloadingText(`Error : ${e}`);
        setspin(false);
        setstatusInfoMode("error");
      });
  }
  function OnSelectChange(type, value) {
    setFormdata((Formdata) => ({ ...Formdata, [type]: value }));
  }
  const statusInfoCallBack = () => {
    setshowModal(false);
    window.location.reload();
  };


  const handleSearch = (value) => {
    setreferenceJob(value);
  };
  const handleJobReference = () => {
    Api.post("job_detail/GetRefJobNo", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      RefJobNo: referenceJob,
    })
      .then((res) => {
        if (res.data.result.code === "P") {
          setReferenceData(res.data.data === null ? [] : res.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const handleJobIDReference = (value) => {
    setrefJob(value)
    const result = referenceData.filter(data => data.so_id === value);
    if(result.length === 1){
      form.setFieldsValue({
        problemtype: result[0]["problem_type_id"],
        servicecase: result[0]["service_cause_id"],
        servicetype: result[0]["service_type_id"],
      });
      headerdata["ref_job_id"] = result[0]["job_id"];
      setrefJobIDGetData(result[0]["job_id"]);
    }

  };

  return (
    <>
      <Modal
        title={null}
        centered
        visible={showModal}
        footer={null}
        closable={false}
      >
        <StatusInfo
          callbackFunction={statusInfoCallBack}
          showSpinIcon={spin}
          statusText={loadingText}
          mode={statusInfoMode}
        ></StatusInfo>
      </Modal>
      <Form {...layout} form={form} layout="horizontal" onFinish={OnSubmit}>
        <div className="col my-2 px-2">
          <Collapse ghost collapsible="disabled" defaultActiveKey={["1"]}>
            <Panel
              showArrow={false}
              header={
                <div className="font-thai-b fs-18">
                  <span className="c-blue text-uppercase">ข้อมูลการซ่อม</span>
                </div>
              }
              key="1"
              className="font-thai-r fs-18 my-0"
            >
              <Form.Item
                label="ปัญหาที่พบ"
                name="problemtype"
                rules={[{ required: true, message: "กรุณาเลือก ปัญหาที่พบ" }]}
              >
                <Select
                  placeholder="Select"
                  onChange={OnSelectChange.bind(this, "problemtype")}
                  disabled={checkRef}
                >
                  {ProblemType?.map((data, index) => (
                    <Select.Option
                      key={`fixproblem_map_problem_type_${index}`}
                      value={data.problem_type_id}
                    >
                      <span className="default-thai-font">
                        {data.problem_type_name}
                      </span>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="สาเหตุการเสีย"
                name="servicecase"
                rules={[
                  { required: true, message: "กรุณาเลือก สาเหตุการเสีย" },
                ]}
              >
                <Select
                  placeholder="Select"
                  onChange={OnSelectChange.bind(this, "servicecase")}
                  disabled={checkRef}
                >
                  {SeviceCase?.map((data, index) => (
                    <Select.Option
                      key={`fixedproblem_map_serviceCase_${index}`}
                      value={data.service_cause_id}
                    >
                      <span className="default-thai-font">
                        {data.service_cause_name}
                      </span>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="ประเภทการซ่อม"
                name="servicetype"
                rules={[
                  { required: true, message: "กรุณาเลือก ประเภทการซ่อม" },
                ]}
              >
                <Select
                  placeholder="Select"
                  onChange={OnSelectChange.bind(this, "servicetype")}
                  disabled={checkRef}
                >
                  {ServiceType?.map((data, index) => (
                    <Select.Option
                      key={`fiexdproblem_map_ServiveType_${index}`}
                      value={data.service_type_id}
                    >
                      <span className="default-thai-font">
                        {data.service_type_name}
                      </span>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Reference Job"
                name="refJob"
              // rules={[
              //   { required: true, message: "กรุณาเลือก ประเภทการซ่อม" },
              // ]}
              >
                <Checkbox onClick={(e) => setCheckRef(e.target.checked)} ></Checkbox>
                {checkRef ?
                  <div className="row mt-2">
                    <div className="col-12" style={{ marginLeft: "-10px" }}>
                      {/* <Input placeholder="Reference Job" className="w-100" onBlur={(e) => setreferenceJob(e.target.value)} /> */}
                      <AutoComplete
                        style={{
                          width: "100%",
                        }}
                        onSearch={handleSearch}
                        onKeyDown={(e) => e.key === "Enter" ? handleJobReference() : null }
                        onBlur={(e) => handleJobIDReference(e.target.value)}
                        placeholder="Input Reference Job"
                      >
                        {referenceData.map((item ,index) => (
                          <Option key={index} value={item.so_id}>
                            {item.so_id}
                          </Option>
                        ))}
                      </AutoComplete>
                    </div>
                  </div>
                  : null}
              </Form.Item>
            </Panel>
          </Collapse>
          <Collapse ghost collapsible="disabled" defaultActiveKey={["1"]}>
            <Panel
              showArrow={false}
              header={
                <div className="font-thai-b fs-18">
                  <span className="c-blue text-uppercase">ระบุการซ่อม</span>
                </div>
              }
              key="1"
              className="font-thai-r fs-18"
            >
              <div className="row">
                <MapRepairPoint jobData={headerdata} actionSatus={checkRef} refJobID={{job_id : refJobIDGetData }}/>
              </div>
            </Panel>
          </Collapse>
          {/* <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 10 }}> */}
          <div className="text-center">
            <Renderbtn
              renderBtn={{
                visible: true,
                html_tag: "button",
                type: "ImagewithText",
                text: `บันทึกซ่อมเรียบร้อย`,
                icon_align: "left",
                image_path: "/icon/bbtec/button/md/fix-problem.svg",
                css: "btn btn-sm btn-primary",
              }}
              btnMiddleware={() => form.submit()}
              index="view_submit_form"
              item={null}
              disable={false}
            ></Renderbtn>
          </div>
          {/* </Form.Item> */}
        </div>
      </Form>
    </>
  );
}
